<template>
  <div :class='["ropeList",isTitle?"":"ropeContent"]'>
     <div class="bgWhite"></div>
     <div class='ropeCon' >
        <img src="@/assets/img/step/report_banner.jpg" class="imgs">
        <div class='tab'>
           <van-tabs v-model="active" title-active-color='#0A59F7' color='#0A59F7' :ellipsis='false' @change='getList'>
               <van-tab title="学生组" name='1'></van-tab>
               <van-tab title="家长组" name='2'></van-tab>
               <van-tab title="老师组" name='3'></van-tab>
           </van-tabs>
           <div class="tabCon">
              <span :class='{active:reportType==1}' @click="getTab(1)">今日排行</span><span :class='{active:reportType==2}' @click="getTab(2)">总排行</span>
           </div>
        </div>
        <div class="list">
             <div class='flex-between top'>
                <p>排名</p>
                <p>姓名</p>
                <p v-if="active==1">班级</p>
                <p v-else-if="active==3">分组</p>
                <p>成绩(个)</p>
             </div>
             <div v-for="(item,i) in list" :key='i' class="flex-between">
                 <p :class='"num"+item.order'>{{item.order}}</p>
                 <p>{{item.studentName}}</p>
                 <p v-if="active==1||active==3">{{item.className}}</p>
                 <p>{{item.num||'0'}}</p>
             </div>
        </div>
 
       <div class='noData' v-if="text&&list.length==0"><div><img :src='require("@/assets/img/nodata.png")'><br />{{text}}</div></div>
     </div>
  </div>
</template>
<script>
import {getBestSkipReport} from "@/api/api.report";
  export default {
    data() {
      return {
        list:[],
        text:'',
        active:1,
        reportType:1,
        isTitle:true
      }
    },
   created(){
     if(!this.loginUser){//
        document.title='跳绳比赛';
        this.isTitle=false;
     }
     this.getList();
    },
    methods: {
      getTab(num){
        this.reportType=num;
        this.getList();
      },
       getList(){
        this.list=[];
         getBestSkipReport({
              schoolId:'11',
              groupCode:this.active,
              reportType:this.reportType
           }).then((data) => {
            if (data && data.result.length>0) {
                  this.list=data.result
            }else{
              this.text='暂无数据';
            }
         })
       },
   
       
    },
  }
</script>
<style lang="scss" >
.ropeList{
  min-height: 100%;
  font-size: .14rem;
  .bgWhite{
    position: fixed;
    background: #fff;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
  }
  .ropeCon{
    position: relative;
  }
  .imgs{
    width:100%;
  }
  .tabCon{
    padding-top: .15rem;
    border-top: 1px solid #e9e9e9;
    span{
      padding:.05rem;
      margin:0 .1rem;
      border-radius:5px;
      &.active{
        background:#e3f3fc;
        color:#0a59f7;
      }
    }
  }
  .list{
     line-height: .55rem;
     font-size: .15rem;
     color:#7f7f7f;
     
     div{
       p{
         flex: 1;
         text-align: center;
         overflow: hidden;
         white-space: nowrap;
         text-overflow: ellipsis;
         img{
           width:.26rem;
           vertical-align: middle;
         }
         .arrow{
           margin-left: 10px;
         }
         &:last-child{
          width:30%;
          flex:0 0 30%;
         }
       }
     }
     .num1{
       background:url(../../assets/img/step/num1.png) no-repeat center top;
       background-size:.26rem auto ;
       width:.26rem;
       line-height: .26rem;
       color:#fff;
     }
     .num2{
       background:url(../../assets/img/step/num2.png) no-repeat center top;
       background-size:.26rem auto ;
       width:.26rem;
       line-height: .26rem;
       color:#fff;
     }
     .num3{
       background:url(../../assets/img/step/num3.png) no-repeat center top;
       background-size:.26rem auto ;
       width:.26rem;
       line-height: .26rem;
       color:#fff;
     }

  }
  
@media screen and (max-width:400px){
  .list div p{
       &:first-child{
           flex:0 0 50px;
         }
  }
}
}
.ropeContent{
    .bgWhite{
      z-index: 3;
    }
    .ropeCon{
      z-index: 3;
      margin-top: -0.44rem;
    }
  }
</style>